// @flow

import React from 'react';

import Keydown, { type Props } from './Keydown';

export default (props: Props) => <Keydown isGlobalEvent={true} {...props} />;
